import { render } from "./index.vue?vue&type=template&id=b2aca836"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/tab/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2aca836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2aca836', __exports__)) {
    api.reload('b2aca836', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b2aca836", () => {
    api.rerender('b2aca836', render)
  })

}


export default __exports__